module.exports = __webpack_public_path__ + "media/1x1/so-c1561217.svg";